import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LSRNavigationService {
    constructor(public dialog: MatDialog) {}

    private bhNavigation = new BehaviorSubject<FuseNavigationItem[]>(null);
    navigation = this.bhNavigation.asObservable();

    changeNavigation(nav: FuseNavigationItem[]) {
        this.bhNavigation.next(nav);
    }
}
